<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="value"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="gradiente">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ notice.title }}</v-toolbar-title>
        </v-toolbar>
        <v-container fluid style="max-height: 93vh;" class="scrollDesign">
          <v-layout row wrap>
            <!-- Left panel -->
            <v-flex xs12 sm6 xl4 class="scrollDesign">
              <v-subheader>Datos generales</v-subheader>
              <v-divider></v-divider>
              <noticeSummary
                :notice="notice"
                :showDescription="true"
                v-on:parent-confirm="showParentConfirm"
                v-on:parent-attendance="showParentAttendance"
                v-on:parent-watched="showParentWatched"
              ></noticeSummary>
            </v-flex>
            <!-- Left panel -->

            <!-- Right panel -->
            <v-flex xs12 sm6 xl8>
              <v-container grid-list-xl>
                <v-layout row wrap justify-center>
                  <v-flex xs8>
                    <v-container
                      fluid
                      grid-list-xs
                      v-if="notice.imageStorage != null && notice.imageStorage.length > 0"
                      style="max-height: 75vh;"
                      class="scrollDesign"
                    >
                      <v-layout wrap row justify-center>
                        <v-slide-y-transition
                          v-for="(image, key) in notice.imageStorage"
                          :key="key"
                        >
                          <v-flex :key="key" xs12 xl8>
                            <v-card class="d-flex align-center" dark>
                              <v-img :src="image.miniObjUrl"></v-img>
                            </v-card>
                          </v-flex>
                        </v-slide-y-transition>
                      </v-layout>
                    </v-container>
                    <v-img
                      v-else-if="notice.type == 'A'"
                      :src="require('@/assets/notices/SKLB-Aviso 3.png')"
                    ></v-img>
                    <v-img
                      v-else-if="notice.type == 'E'"
                      :src="require('@/assets/notices/SKLB-Evento.png')"
                    ></v-img>
                    <v-img
                      v-else-if="notice.type == 'R'"
                      :src="require('@/assets/notices/SKLB-informe.png')"
                    ></v-img>
                    <v-img
                      v-else-if="notice.type == 'P'"
                      :src="require('@/assets/notices/SKLB-Permiso.png')"
                    ></v-img>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
            <!-- Right panel -->
          </v-layout>
        </v-container>
      </v-card>
      <ParentConfirmation
        v-model="modals.pConf"
        :notice="notice"
        :title="'Confirmación de tutores'"
      ></ParentConfirmation>
      <ParentAttendance
        v-model="modals.pAtt"
        :notice="notice"
        :title="'Asistencia de tutores'"
      ></ParentAttendance>
      <ParentWatched 
        v-model="modals.pWat" 
        :notice="notice"
      ></ParentWatched>
    </v-dialog>
  </v-layout>
</template>

<script>
import moment from "moment";
import NoticeSummary from "../Sections/Notices/NoticeSummary";
import ParentConfirmation from "./ParentConfirmation";
import ParentAttendance from "./ParentAttendance";
import ParentWatched from "./ParentWatched";

export default {
  components: {
    NoticeSummary,
    ParentConfirmation,
    ParentAttendance,
    ParentWatched
  },
  props: ["value", "notice"],
  data: () => ({
    modals: {
      pConf: false,
      pAtt: false,
      pWat: false
    },
  }),
  watch: {
    value() {
      if (this.value) {
        this.$forceUpdate();
      }
    }
  },
  methods: {
    close() {
      this.$emit("input", !this.value);
    },
    showParentConfirm(e) {
      this.modals.pConf = true;
    },
    showParentAttendance(e) {
      this.modals.pAtt = true;
    },
    showParentWatched(e) {
      this.modals.pWat = true;
    }
  }
};
</script>

<style>
</style>
